import { render } from "./relesedoc.vue?vue&type=template&id=5a9d039a"
import script from "./relesedoc.vue?vue&type=script&lang=js"
export * from "./relesedoc.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__